import styles from './CompanyInfo.module.scss'

const CompanyinfoBox = ({title, info, children}) => {
    return (
        <div>
          <span className={styles['companyMiniTitle']}>{title}</span>
          {info && <span className={styles["companyDetail"]}>{info}</span>}
          {children}
        </div>
    )
}

export default CompanyinfoBox